import { useContext, useEffect, useRef, useState } from "react";
import Accordion from 'react-bootstrap/Accordion';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Column, Panel, Row, Spinner, Select } from "../../../components";
import { RootState } from "../../../shared/store";
import { policyStatusMap } from "../../../shared/util/constant";
import { PolicyDtoRead } from "../../model/PolicyDtoRead";
import CustomerPolicySummary from "../CustomerPolicySummary";
import CustomerCoInsured from "./customer-coinsured/Customer-CoInsured";
import CustomerInsured from "./customer-insured-name/CustomerInsuredName";
import "./CustomerEditPolicyDetails.scss";
import PolicyDetailService from "./CustomerEditPolicyDetailsService";
import { startFetchingCustomerPolicies, storeCustomerPolicies, updateSelectedLOBDetails, updateSelectedPolicyDetails } from "../../customer-slice/Customer-slice";
import { toast } from 'react-toastify'
import * as constant from '../../../shared/util/constant'
import { CustomerPolicyDetails as cstPolicyDetails } from '../../../shared/util/constant'
import Logger from '../../../shared/services/Logger'
import { CustomerPolicyDetailLabels as cstPolicyDetailLabel } from '../../../shared/util/label';
import * as label from '../../../shared/util/label';
import CustomerBasicPolicyInfo from "./customer-basic-policy/CustomerBasicPolicyInfo";
import { PolicyTransactionsReadDto } from "../../model/PolicyTransactionsReadDto";
import { CommonUtility } from "../../../Services/CommonUtility";
import CustomerEditPolicyBasicCoverageGrid from "./customer-basic-coverage/CustomerEditPolicyBasicCoverageGrid";
import CustomerPolicyLocationGrid from "./customer-policy-location/CustomerPolicyLocationGrid";
import PolicyTransactionPremiumGrid from "./customer-policy-transpremium/PolicyTransactionPremiumGrid";
import CustomerAdditionalInterestsList from "./customer-additional-interests/CustomerAdditionalInterestsList";
import { updateLookupData } from "../../customer-slice/Customer-lookup-slice";
import CustomerActivityService from "../../customer-activity/CustomerActivityService";
import { SliderDataAction, updateSliderData } from "../../customer-slider-content/CustomerSliderContext";
import CustomerEditPolicyEndorsementGrid from "./customer-basic-coverage/CustomerEditPolicyEndorsementGrid";
import { PolicyLOBReadDto } from "../../model/PolicyLOBReadDto";
import CustomerPolicyUnderwriting from "./customer-policy-underwriting/CustomerPolicyUnderwriting";
import CustomerBasicVehicleGrid from "./customer-basic-vehicle/CustomerBasicVehicleGrid";
import CustomerEditPolicyFloodUnderwriting from "./customer-policy-underwriting/CustomerEditPolicyFloodUnderwriting";
import CustomerPolicyListService from "../CustomerPolicyListService";
import { PolicyEventDto } from "../../model/PolicyEventDto";
import { FloatingLabel, Form, InputGroup, } from "react-bootstrap";
import * as labelconstant from '../../../shared/util/label';
import CustomerEditPolicyFloodCoverageGrid from "./customer-flood-coverage/CustomerEditPolicyFloodCoverageGrid";
import DatePicker from "react-datepicker";
import CommissionReconciliation from "../customer-policy-commission/CommissionReconciliation";
import { AbilityContext } from "../../../shared/abilities/AbilityContext";

export interface ICustomerEditPolicyDetails {
    policySummary: PolicyDtoRead;
    policyTransactionSelected?: PolicyTransactionsReadDto;
    onAddNewPolicy?: () => void;
};

const CustomerEditPolicyDetails: React.FunctionComponent<ICustomerEditPolicyDetails> = (props) => {
    const history = useHistory();
    const dispatch = useDispatch()
    const policySummary = props.policySummary;
    const policyEventDetails = props.policyTransactionSelected;
    const policyId = policySummary?.id;
    const polEventId = policyEventDetails?.polEventId ?? "";
    const policyDetailKey = CommonUtility.getPolicyDetailKey(policyId, polEventId);
    const policyDetailService = new PolicyDetailService();
    const customerActivityService = new CustomerActivityService();
    const [originalPolicyDetails, setOriginalPolicyDetails] = useState<PolicyDtoRead | null>(null)
    const customerpolicyDetail = useSelector((state: RootState) => state?.customerSlice);
    const stateUSLookup = useSelector((state: RootState) => state?.LookupState.stateUSList);
    const attachTypeLookup = useSelector((state: RootState) => state?.LookupState.attachTypeList);
    const policyTypeList = useSelector((state: RootState) => state?.LookupState.policyTypeList);
    const policyTermStatusList = useSelector((state: RootState) => state?.LookupState.policyTermStatusList);
    const policyBusinessTypeList = useSelector((state: RootState) => state?.LookupState.policyBusinessTypeList);
    const policyPaymentPlanList = useSelector((state: RootState) => state?.LookupState.policyPaymentPlanList);
    const lineOfBusinessList = useSelector((state: RootState) => state?.LookupState.lineOfBusinessList);
    const occupancyTypeList = useSelector((state: RootState) => state?.LookupState.occupancyTypeList);
    const residenceTypeList = useSelector((state: RootState) => state?.LookupState.residenceTypeList);
    const constructionTypeList = useSelector((state: RootState) => state?.LookupState.constructionTypeList);
    const roofMaterialTypeList = useSelector((state: RootState) => state?.LookupState.roofMaterialTypeList);
    const heatTypeList = useSelector((state: RootState) => state?.LookupState.heatTypeList);
    const sprinklerTypeList = useSelector((state: RootState) => state?.LookupState.sprinklerTypeList);
    const dwellingConditionTypeList = useSelector((state: RootState) => state?.LookupState.dwellingConditionTypeList);
    const stormShutterTypeList = useSelector((state: RootState) => state?.LookupState.stormShutterTypeList);
    const dwellingLocTypeList = useSelector((state: RootState) => state?.LookupState.dwellingLocTypeList);
    const secondaryHeatTypeList = useSelector((state: RootState) => state?.LookupState.secondaryHeatTypeList);
    const foundationTypeList = useSelector((state: RootState) => state?.LookupState.foundationTypeList);
    const transactionTypeList = useSelector((state: RootState) => state?.LookupState.transactionTypeList);
    const formTypeList = useSelector((state: RootState) => state?.LookupState.formTypeList);
    const customerSliderState = useSelector((state: RootState) => state?.CustomerSliderState);
    const companyList = useSelector((state: RootState) => state?.LookupState.companyList);
    const parentCompanyList = useSelector((state: RootState) => state?.LookupState.parentCompaniesList);
    const writingCompanyList = useSelector((state: RootState) => state?.LookupState.writingCompaniesList);
    const sourceList = useSelector((state: RootState) => state?.LookupState.sourceTypeList);    
    const cancellationReasonList = useSelector((state: RootState) => state?.LookupState.cancellationReasonList);
    const lobApplicationList = useSelector((state: RootState) => state?.LookupState.lobApplicationsList);
    const basementTypeList = useSelector((state: RootState) => state?.LookupState.basementTypeList);
    const numberOfFloorsTypeList = useSelector((state: RootState) => state?.LookupState.numberOfFloorsTypeList);
    const contentLocationTypeList = useSelector((state: RootState) => state?.LookupState.contentLocationTypeList);
    const ratingTypeList = useSelector((state: RootState) => state?.LookupState.ratingTypeList);
    const nearestShoreTypeList = useSelector((state: RootState) => state?.LookupState.nearestShoreTypeList);
    const elevatedFoundationTypeList = useSelector((state: RootState) => state?.LookupState.elevatedFoundationTypeList);
    const elevatedMaterialTypeList = useSelector((state: RootState) => state?.LookupState.elevatedMaterialTypeList);
    const enclosedForOtherPurposeTypeList = useSelector((state: RootState) => state?.LookupState.enclosedForOtherPurposeTypeList);
    const floodOccupancyTypeList = useSelector((state: RootState) => state?.LookupState.floodOccupancyTypeList);
    const protectionDeviceTypeList = useSelector((state: RootState) => state?.LookupState.protectionDeviceTypeList);
    const interestTypeList = useSelector((state: RootState) => state?.LookupState.interestTypeList);
    const priorPolicies = [...customerSliderState.activityPage.policiesForSelect];
    const [policyTransactionDetails, setPolicyTransactionDetails] = useState<PolicyEventDto>(null);
    const [lobDetails, setLobDetails] = useState<PolicyLOBReadDto[]>([]);
    const [selectedLOB, setSelectedLobDetails] = useState<PolicyLOBReadDto>({} as PolicyLOBReadDto);
    const [formValidation, setFormValidation] = useState<any>({});
    const [isLoading, setIsLoading] = useState(false);
    const [selectedLOBCodeId, setSelectedLOBCodeId] = useState<string>('');
    const [showCommissions, setShowCommissions] = useState(false);
    const ability = useContext(AbilityContext);
    const canViewCommissions = ability.can("view", "Policy", "Commission");

    // Controls for Tabbing order
    const firstControlTransactionTypeRef = useRef(null);
    const lastControlButtonRef = useRef(null);
    let tabIndexCounter = 65 ; // Starting tab index for first control

    const cancellationTranTypes = [
        constant.EventTransactionType.XLC,
        constant.EventTransactionType.XLN
    ];

    let isAddressHasValue = true;
    let policyBarStyle = {};

    if (policySummary) {
        if (policySummary?.policyTermStatusId && policyStatusMap[policySummary.policyTermStatusId]) {
            policyBarStyle = policyStatusMap[policySummary.policyTermStatusId];
        }

        if (policySummary?.address1 == '' && policySummary.address2 == '' && policySummary.city == ''
            && policySummary.state == '' && policySummary.zipCode == '') {
            isAddressHasValue = false;
        }
    }

    const getLobLabel = (lobCodeId: string) => {
        let lobFound = lineOfBusinessList?.find(lob => lob.value === lobCodeId);
        return lobFound ? lobFound.label : "";
    };

    // Check if any LOB in the policy should display 'Property Address' instead of 'Policy Location'
    const shouldShowPropertyAddress = () => {
        return lobDetails?.some(lob => constant.PROPERTY_ADDRESS_LOB_IDS.includes(lob.lobCodeId));
    };

    const fetchLookups = async () => {
        if (
            !stateUSLookup || stateUSLookup.length === 0 ||
            !attachTypeLookup || attachTypeLookup.length === 0 ||
            !policyTypeList || policyTypeList.length === 0 ||
            !policyTermStatusList || policyTermStatusList.length === 0 ||
            !policyBusinessTypeList || policyBusinessTypeList.length === 0 ||
            !policyPaymentPlanList || policyPaymentPlanList.length === 0 ||
            !lineOfBusinessList || lineOfBusinessList.length === 0 ||
            !occupancyTypeList || occupancyTypeList.length === 0 ||
            !residenceTypeList || residenceTypeList.length === 0 ||
            !constructionTypeList || constructionTypeList.length === 0 ||
            !roofMaterialTypeList || roofMaterialTypeList.length === 0 ||
            !heatTypeList || heatTypeList.length === 0 ||
            !sprinklerTypeList || sprinklerTypeList.length === 0 ||
            !dwellingConditionTypeList || dwellingConditionTypeList.length === 0 ||
            !stormShutterTypeList || stormShutterTypeList.length === 0 ||
            !dwellingLocTypeList || dwellingLocTypeList.length === 0 ||
            !secondaryHeatTypeList || secondaryHeatTypeList.length === 0 ||
            !foundationTypeList || foundationTypeList.length === 0 ||
            !transactionTypeList || transactionTypeList.length === 0 ||
            !parentCompanyList || parentCompanyList.length === 0 ||
            !writingCompanyList || writingCompanyList.length === 0 ||
            !companyList || companyList.length === 0 ||
            !sourceList || sourceList.length === 0 ||
            !cancellationReasonList || cancellationReasonList.length === 0 ||
            !lobApplicationList || lobApplicationList.length === 0 ||
            !formTypeList || formTypeList.length === 0 ||
            !basementTypeList || basementTypeList.length === 0 ||
            !numberOfFloorsTypeList || numberOfFloorsTypeList.length === 0 ||
            !contentLocationTypeList || contentLocationTypeList.length === 0 ||
            !ratingTypeList || ratingTypeList.length === 0 ||
            !nearestShoreTypeList || nearestShoreTypeList.length === 0 ||
            !elevatedFoundationTypeList || elevatedFoundationTypeList.length === 0 ||
            !elevatedMaterialTypeList || elevatedMaterialTypeList.length === 0 ||
            !enclosedForOtherPurposeTypeList || enclosedForOtherPurposeTypeList.length === 0 ||
            !floodOccupancyTypeList || floodOccupancyTypeList.length === 0 ||
            !protectionDeviceTypeList || protectionDeviceTypeList.length === 0 ||
            !interestTypeList || interestTypeList.length === 0
        ) {
            let lookupData = await policyDetailService.fetchDropDownData();
            if (lookupData.stateUSLookup) dispatch(updateLookupData({ data: lookupData.stateUSLookup, type: constant.SlicerLookUpConstant.US_STATE }));
            if (lookupData.attachTypeLookup) dispatch(updateLookupData({ data: lookupData.attachTypeLookup, type: constant.SlicerLookUpConstant.ATTACH_TYPE }));
            if (lookupData.policyTypeLookup) dispatch(updateLookupData({ data: lookupData.policyTypeLookup, type: constant.SlicerLookUpConstant.POLICY_TYPE }));
            if (lookupData.policyTermStatusLookup) dispatch(updateLookupData({ data: lookupData.policyTermStatusLookup, type: constant.SlicerLookUpConstant.POLICY_TERM_STATUS }));
            if (lookupData.policyBusinessTypeLookup) dispatch(updateLookupData({ data: lookupData.policyBusinessTypeLookup, type: constant.SlicerLookUpConstant.POLICY_BUSINESS_TYPE }));
            if (lookupData.policyPaymentPlanLookup) dispatch(updateLookupData({ data: lookupData.policyPaymentPlanLookup, type: constant.SlicerLookUpConstant.POLICY_PAYMENT_PLAN }));
            if (lookupData.lobsLookup) dispatch(updateLookupData({ data: lookupData.lobsLookup, type: constant.SlicerLookUpConstant.Line_Of_Business }));
            if (lookupData.occupancyTypeLookup) dispatch(updateLookupData({ data: lookupData.occupancyTypeLookup, type: constant.SlicerLookUpConstant.OCCUPANCY_TYPE }));
            if (lookupData.residenceTypeLookup) dispatch(updateLookupData({ data: lookupData.residenceTypeLookup, type: constant.SlicerLookUpConstant.RESIDENCE_TYPE }));
            if (lookupData.constructionTypeLookup) dispatch(updateLookupData({ data: lookupData.constructionTypeLookup, type: constant.SlicerLookUpConstant.CONSTRUCTION_TYPE }));
            if (lookupData.roofMaterialTypeLookup) dispatch(updateLookupData({ data: lookupData.roofMaterialTypeLookup, type: constant.SlicerLookUpConstant.ROOF_MATERIAL_TYPE }));
            if (lookupData.heatTypeLookup) dispatch(updateLookupData({ data: lookupData.heatTypeLookup, type: constant.SlicerLookUpConstant.HEAT_TYPE }));
            if (lookupData.sprinklerTypeLookup) dispatch(updateLookupData({ data: lookupData.sprinklerTypeLookup, type: constant.SlicerLookUpConstant.SPRINKLER_TYPE }));
            if (lookupData.dwellingConditionTypeLookup) dispatch(updateLookupData({ data: lookupData.dwellingConditionTypeLookup, type: constant.SlicerLookUpConstant.DWELLING_CONDITION_TYPE }));
            if (lookupData.stormShutterTypeLookup) dispatch(updateLookupData({ data: lookupData.stormShutterTypeLookup, type: constant.SlicerLookUpConstant.STORM_SHUTTER_TYPE }));
            if (lookupData.dwellingLocTypeLookup) dispatch(updateLookupData({ data: lookupData.dwellingLocTypeLookup, type: constant.SlicerLookUpConstant.DWELLING_LOC_TYPE }));
            if (lookupData.secondaryHeatTypeLookup) dispatch(updateLookupData({ data: lookupData.secondaryHeatTypeLookup, type: constant.SlicerLookUpConstant.SECONDARY_HEAT_TYPE }));
            if (lookupData.foundationTypeLookup) dispatch(updateLookupData({ data: lookupData.foundationTypeLookup, type: constant.SlicerLookUpConstant.FOUNDATION_TYPE }));     
            if (lookupData.transactionTypeLookup) dispatch(updateLookupData({ data: lookupData.transactionTypeLookup, type: constant.SlicerLookUpConstant.TRANSACTION_TYPE }));  
            if (lookupData.foundationTypeLookup) dispatch(updateLookupData({ data: lookupData.foundationTypeLookup, type: constant.SlicerLookUpConstant.FOUNDATION_TYPE }));       
            if (lookupData.parentCompanyLookup) dispatch(updateLookupData({ data: lookupData.parentCompanyLookup, type: constant.SlicerLookUpConstant.PARENT_COMPANIES }));
            if (lookupData.writingCompanyLookup) dispatch(updateLookupData({ data: lookupData.writingCompanyLookup, type: constant.SlicerLookUpConstant.WRITING_COMPANIES }));
            if (lookupData.sourceListLookup) dispatch(updateLookupData({ data: lookupData.sourceListLookup, type: constant.SlicerLookUpConstant.Source_Type }));
            if (lookupData.cancellationReasonLookup) dispatch(updateLookupData({ data: lookupData.cancellationReasonLookup, type: constant.SlicerLookUpConstant.Cancellation_Reason }));
            if (lookupData.lobApplicationLookup) dispatch(updateLookupData({ data: lookupData.lobApplicationLookup, type: constant.SlicerLookUpConstant.LOB_APPLICATIONS }) );
            if (lookupData.companyListLookup) dispatch(updateLookupData({ data: lookupData.companyListLookup, type: constant.SlicerLookUpConstant.COMPANY_LIST }));
            if (lookupData.formTypeLookup) dispatch(updateLookupData({ data: lookupData.formTypeLookup, type: constant.SlicerLookUpConstant.FORM_TYPE }) );
            if (lookupData.basementTypeLookup) dispatch(updateLookupData({ data: lookupData.basementTypeLookup, type: constant.SlicerLookUpConstant.BASEMENT_TYPE }));
            if (lookupData.numberOfFloorsTypeLookup) dispatch(updateLookupData({ data: lookupData.numberOfFloorsTypeLookup, type: constant.SlicerLookUpConstant.NUMBER_OF_FLOORS_TYPE }));
            if (lookupData.contentLocationTypeLookup) dispatch(updateLookupData({ data: lookupData.contentLocationTypeLookup, type: constant.SlicerLookUpConstant.CONTENT_LOCATION_TYPE }));
            if (lookupData.ratingTypeLookup) dispatch(updateLookupData({ data: lookupData.ratingTypeLookup, type: constant.SlicerLookUpConstant.RATING_TYPE }));
            if (lookupData.nearestShoreTypeLookup) dispatch(updateLookupData({ data: lookupData.nearestShoreTypeLookup, type: constant.SlicerLookUpConstant.NEAREST_SHORE_TYPE }));
            if (lookupData.elevatedFoundationTypeLookup) dispatch(updateLookupData({ data: lookupData.elevatedFoundationTypeLookup, type: constant.SlicerLookUpConstant.ELEVATED_FOUNDATION_TYPE }));
            if (lookupData.elevatedMaterialTypeLookup) dispatch(updateLookupData({ data: lookupData.elevatedMaterialTypeLookup, type: constant.SlicerLookUpConstant.ELEVATED_MATERIAL_TYPE }));
            if (lookupData.enclosedForOtherPurposeTypeLookup) dispatch(updateLookupData({ data: lookupData.enclosedForOtherPurposeTypeLookup, type: constant.SlicerLookUpConstant.ENCLOSED_FOR_OTHER_PURPOSE_TYPE }));
            if (lookupData.floodOccupancyTypeLookup) dispatch(updateLookupData({ data: lookupData.floodOccupancyTypeLookup, type: constant.SlicerLookUpConstant.FLOOD_OCCUPANCY_TYPE }));
            if (lookupData.protectionDeviceTypeLookup) dispatch(updateLookupData({ data: lookupData.protectionDeviceTypeLookup, type: constant.SlicerLookUpConstant.PROTECTION_DEVICE_TYPE }));
            if (lookupData.interestTypeLookup) dispatch(updateLookupData({ data: lookupData.interestTypeLookup, type: constant.SlicerLookUpConstant.INTEREST_TYPE }));
        }
        if (!priorPolicies || priorPolicies.length == 0) {
            let custPolicyData = await customerActivityService.getPoliciesForCustomer(policySummary.custId);
            dispatch(updateSliderData({ type: SliderDataAction.ActivityPolicyListUpdate, data: custPolicyData }));
        }
    };

    const validateRequiredYearFields = (): string[] => {
        const selectedLocation = customerpolicyDetail.selectedLocationDetails;
        if (!selectedLocation?.policyHomes?.length) return [];
        const home = selectedLocation.policyHomes[0];
        return policyDetailService.validateAllRenovationYears(home);
    };

    const mapYearErrorsToFormValidation = (errorMessages: string[]): any => {
        const formValidationMap: any = {};
        const fieldMapping: { [key: string]: string } = {
            [constant.RenovationYearValidation.WIRING_YEAR_ERROR]: 'wiringYear',
            [constant.RenovationYearValidation.PLUMBING_YEAR_ERROR]: 'plumbingYear',
            [constant.RenovationYearValidation.HEATING_YEAR_ERROR]: 'heatingYear',
            [constant.RenovationYearValidation.ROOFING_YEAR_ERROR]: 'roofingYear',
            [constant.RenovationYearValidation.EXTERIOR_PAINT_YEAR_ERROR]: 'exteriorPaint',
        };

        errorMessages.forEach(errorMsg => {
            const fieldName = fieldMapping[errorMsg];
            if (fieldName) {
                formValidationMap[fieldName] = { isValid: false, warningText: errorMsg };
            }
        });

        return formValidationMap;
    };

    const handleSaveButtonClick = async () => {
        // Deep copy to prevent mutations from corrupting Redux cache
        let policyDetails = CommonUtility.deepCloneObject(customerpolicyDetail.selectedPolicyDetails?.[policyDetailKey]);
        if (!policyDetails) {
            toast.error(cstPolicyDetails.NO_POLICY_TO_SAVE, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }
        policyDetails = mergeLobFields(policyDetails, lobDetails);

        // TEMPORARY WORKAROUND: Copying coInsureds from PolicyDto to PolicyEventDto before saving.
        // Should remove after backend is fixed.
        if (policyDetails.policyEvents && policyDetails.policyCoInsureds) {
            const policyEventId = policyDetails.policyEvents.findIndex((policyEvent: any) => policyEvent.id === polEventId);
            if (policyEventId !== -1) {
                const event = policyDetails.policyEvents[policyEventId];
                const updatedEvent = { ...event, policyCoInsureds: [...policyDetails.policyCoInsureds] };
                const updatedPolicyEvents = [...policyDetails.policyEvents];
                updatedPolicyEvents[policyEventId] = updatedEvent;
                policyDetails = { ...policyDetails, policyEvents: updatedPolicyEvents };
            }
        }

        try {         
            const requiredYearErrors = validateRequiredYearFields();
            if (requiredYearErrors.length > 0) {
                // Map year errors to formValidation state for field-level error display
                const yearErrorsMap = mapYearErrorsToFormValidation(requiredYearErrors);
                setFormValidation(yearErrorsMap);
                toast.warn(constant.UNDERWRITING_VALIDATION_ERRORS + '\n' + requiredYearErrors.join('\n'), {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }
            let validationError = policyDetailService.validatePolicyDetails(policyDetails);                             
            setFormValidation(validationError);
            if (Object.keys(validationError).length > 0) {
              toast.warn(constant.POLICY_EDIT_VALIDATION_ERROR_MESSAGE, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
            }
            policyDetails = removeZipcodeHyphon(policyDetails);

            const savedPolicyDetails = await policyDetailService.updatePolicyDetails(policyDetails);
            dispatch(updateSelectedPolicyDetails({ policyId, polEventId, policyDetails: savedPolicyDetails }));
            toast.success(cstPolicyDetails.POLICY_UPDATE_SUCCESSFULLY, {
                position: toast.POSITION.TOP_RIGHT
            });
            if(savedPolicyDetails && savedPolicyDetails.id && savedPolicyDetails.policyNumber){
                fetchCustomerPolicyListForSummary(savedPolicyDetails.custId);
            }
        }
        catch (error) {
            Logger.logError(cstPolicyDetails.POLICY_ERROR_WHILE_SAVING, error);
            if (error.status == 404) {
                toast.error(cstPolicyDetails.POLICY_NOT_FOUND, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
            else {
                toast.error(cstPolicyDetails.POLICY_ERROR_WHILE_SAVING, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }
    };

    function removeZipcodeHyphon(policyDetails) {
        policyDetails.policyLineOfBusinesses = policyDetails.policyLineOfBusinesses.map(lob => {
            if (lob.policyLocations && lob.policyLocations.length > 0) {
                lob.policyLocations = lob.policyLocations.map(location => {
                    if (location.zipCode && location.zipCode.includes("-")) {
                        return { ...location, zipCode: location.zipCode.replace(/-/g, "") };
                    }
                    return location;
                });
            }
            if (lob.policyAdditionalInterests && lob.policyAdditionalInterests.length > 0) {
                lob.policyAdditionalInterests = lob.policyAdditionalInterests.map(interest => {
                    if (interest.zip && interest.zip.indexOf("-") > -1) {
                        return { ...interest, zip: interest.zip.replace("-", "") };
                    }
                    return interest;
                });
            }
            return lob;
        });
        // Immutably update policyInsureds
        if (policyDetails.policyInsureds && policyDetails.policyInsureds.length > 0 && (policyDetails.policyInsureds[0].resZip || policyDetails.policyInsureds[0].mailZip)) {
            policyDetails.policyInsureds = policyDetails.policyInsureds.map((insured, idx) => {
                if (idx === 0 && (insured.resZip || insured.mailZip)) {
                    return {
                        ...insured,
                        resZip: insured.resZip ? insured.resZip.replace("-", "") : insured.resZip,
                        mailZip: insured.mailZip ? insured.mailZip.replace("-", "") : insured.mailZip,
                    };
                }
                return insured;
            });
        }
        // Immutably update policyPreviousAddress
        if (policyDetails.policyPreviousAddress && policyDetails.policyPreviousAddress.length > 0 && policyDetails.policyPreviousAddress[0].zip) {
            policyDetails.policyPreviousAddress = policyDetails.policyPreviousAddress.map((addr, idx) => {
                if (idx === 0 && addr.zip) {
                    return { ...addr, zip: addr.zip.replace("-", "") };
                }
                return addr;
            });
        }
        return policyDetails;
    }

    const fetchCustomerPolicyListForSummary = async (customerId: string) => {
        try {
            dispatch(startFetchingCustomerPolicies());
            const customerPolicyListService = new CustomerPolicyListService();
            const customerPolicies = await customerPolicyListService.fetchCustomerPolicyDetails(customerId);
            customerPolicies.forEach((item) => {
                if (item.zipCode !== undefined && item.zipCode != null && item.zipCode.toString().length > 0) {
                    let val = item.zipCode.toString().replace(/[^0-9-]/g, ''); // Remove non-digit and non-hyphen characters
                    val = val.replace(/-/g, ''); // Remove existing hyphens

                    if (item.zipCode.toString().length > 5) {
                        val = val.slice(0, 5) + '-' + val.slice(5); // Add hyphen after 5 characters
                    }
                    val = val.slice(0, 10); // Limit to 10 characters including hyphen
                    item.zipCode = val;
                }
            });

            dispatch(storeCustomerPolicies(customerPolicies));
        }
        catch (exx) {
            Logger.logError(constant.CUSTOMER_POLICY_LIST_ERROR_WHILE_FETCHING_POLICIES, exx);
            dispatch(storeCustomerPolicies([]));
        }
    }

    const onCancel = async () => {
        dispatch(updateSelectedPolicyDetails({ policyId, polEventId, policyDetails: originalPolicyDetails }));
        history.push(`/customer-view/policies/${policySummary.custId}`)
    }

    const initializeComponent = async () => {
        let policyDetails = customerpolicyDetail.selectedPolicyDetails?.[policyDetailKey];
        if (!policyDetails) {
            try {
                policyDetails = await policyDetailService.getPolicyDetails(policyId, polEventId);
                setOriginalPolicyDetails(CommonUtility.deepCloneObject(policyDetails));
                dispatch(updateSelectedPolicyDetails({ policyId, polEventId, policyDetails }));
                policyDetails = CommonUtility.deepCloneObject(policyDetails);
            }
            catch (error) {
                toast.error(constant.ERROR_MESSAGE_LOAD, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
                });
                Logger.logError(error.toString());
                 // Store null to indicate fetch failed
                dispatch(updateSelectedPolicyDetails({ policyId, polEventId, policyDetails: null }));
            }
        } else {
            // Deep copy to prevent mutations from corrupting Redux cache
            setOriginalPolicyDetails(CommonUtility.deepCloneObject(policyDetails));
            policyDetails = CommonUtility.deepCloneObject(policyDetails);
        }
        if (policyDetails) {
            let lob = policyDetails?.policyLineOfBusinesses || [];
            setLobDetails(lob);
            setSelectedLOBCodeId((lob && lob.length>0)? lob[0].lobCodeId : '');
            // setSelectedLobDetails(lob.length > 0 ? lob[0] : {} as PolicyLOBReadDto);
            setSelectedLobDetails(prev => (prev && prev.id ? prev : (lob.length > 0 ? lob[0] : {} as PolicyLOBReadDto)));
            let polEventDetails = policyDetails?.policyEvents?.find(pe => pe.id === polEventId);
            setPolicyTransactionDetails(polEventDetails || null);
        }
    }

        // Save and close: save, then redirect to policies list
    const handleSaveAndClose = async () => {
        // Deep copy to prevent mutations from corrupting Redux cache
        let policyDetails = CommonUtility.deepCloneObject(customerpolicyDetail.selectedPolicyDetails?.[policyDetailKey]);
        if (!policyDetails) {
            toast.error(cstPolicyDetails.NO_POLICY_TO_SAVE, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }
        policyDetails = mergeLobFields(policyDetails, lobDetails);

        try {
            const requiredYearErrors = validateRequiredYearFields();
            if (requiredYearErrors.length > 0) {
                // Map year errors to formValidation state for field-level error display
                const yearErrorsMap = mapYearErrorsToFormValidation(requiredYearErrors);
                setFormValidation(yearErrorsMap);
                toast.warn(constant.UNDERWRITING_VALIDATION_ERRORS + '\n' + requiredYearErrors.join('\n'), {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }
            let validationError = policyDetailService.validatePolicyDetails(policyDetails);                             
            setFormValidation(validationError);
            if (Object.keys(validationError).length > 0) {
                toast.warn(constant.POLICY_EDIT_VALIDATION_ERROR_MESSAGE, {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }
            policyDetails = removeZipcodeHyphon(policyDetails);
            const savedPolicyDetails = await policyDetailService.updatePolicyDetails(policyDetails);
            dispatch(updateSelectedPolicyDetails({ policyId, polEventId, policyDetails: savedPolicyDetails }));
            toast.success(cstPolicyDetails.POLICY_UPDATE_SUCCESSFULLY, {
                position: toast.POSITION.TOP_RIGHT
            });
            if(savedPolicyDetails && savedPolicyDetails.id && savedPolicyDetails.policyNumber){
                fetchCustomerPolicyListForSummary(savedPolicyDetails.custId);
            }
            // Redirect to policies list
            history.push(`/customer-view/policies/${policySummary.custId}`);
        }
        catch (error) {
            Logger.logError(cstPolicyDetails.POLICY_ERROR_WHILE_SAVING, error);
            if (error.status == 404) {
                toast.error(cstPolicyDetails.POLICY_NOT_FOUND, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
            else {
                toast.error(cstPolicyDetails.POLICY_ERROR_WHILE_SAVING, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }
    };

    const handleClose = () => {
        history.push(`/customer-view/policy-detail/${policySummary.id}`);
    };

    const fetchAllData = async () => {
        setIsLoading(true);
        try {
                await fetchLookups();
                await initializeComponent();
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchAllData();
    }, [policySummary, policyId, polEventId]);


    useEffect(() => {
        dispatch(updateSelectedLOBDetails(selectedLOB || null))
    }, [selectedLOB]);

    const hasValidationError = (key: string) => {
        return formValidation?.[key];
    };

    const handleTransactionTypeChange = (values: any[]) => {
        let newTranType = values[0] as string;
        let selectedOption = transactionTypeList.find(opt => opt.value === newTranType);
        let newTranNote = selectedOption ? selectedOption.label : newTranType;

        setPolicyTransactionDetails({
            ...policyTransactionDetails,
            tranType: newTranType,
            tranNote: newTranNote,
            cancellationReasonId: undefined
        });

        let updatedPolicyDetails = { ...customerpolicyDetail.selectedPolicyDetails?.[policyDetailKey] };
        if (updatedPolicyDetails.policyEvents) {
            updatedPolicyDetails.policyEvents = updatedPolicyDetails.policyEvents.map(policyEvent =>
                policyEvent.id === policyTransactionDetails.id
                    ? {
                        ...policyEvent,
                        tranType: newTranType,
                        tranNote: newTranNote,
                        cancellationReasonId: undefined
                    }
                    : policyEvent
            );
            dispatch(updateSelectedPolicyDetails({ policyId, polEventId, policyDetails: updatedPolicyDetails }));
        }
    };

    const handleCancellationReasonChange = (values: any[]) => {
        const newReasonId = values[0] as string;
        setPolicyTransactionDetails({ ...policyTransactionDetails, cancellationReasonId: newReasonId });

        let updatedPolicyDetails = { ...customerpolicyDetail.selectedPolicyDetails?.[policyDetailKey] };
        if (updatedPolicyDetails.policyEvents) {
            updatedPolicyDetails.policyEvents = updatedPolicyDetails.policyEvents.map(policyEvent =>
                policyEvent.id === policyTransactionDetails.id
                    ? { ...policyEvent, cancellationReasonId: newReasonId }
                    : policyEvent
            );
            dispatch(updateSelectedPolicyDetails({ policyId, polEventId, policyDetails: updatedPolicyDetails }));
        }
    };

    const handleTransactionEffectiveDateChange = (date: Date) => {
        setPolicyTransactionDetails({ ...policyTransactionDetails, tranEffDate: date });

        let updatedPolicyDetails = { ...customerpolicyDetail.selectedPolicyDetails?.[policyDetailKey] };
        if (updatedPolicyDetails.policyEvents) {
            updatedPolicyDetails.policyEvents = updatedPolicyDetails.policyEvents.map(policyEvent =>
                policyEvent.id === policyTransactionDetails.id
                    ? { ...policyEvent, tranEffDate: date }
                    : policyEvent
            );
            dispatch(updateSelectedPolicyDetails({ policyId, polEventId, policyDetails: updatedPolicyDetails }));
        }
    };

    const handleSelectedLobDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedLobDetails({
            ...selectedLOB,
            description: e.target.value
        });
        setLobDetails(lobDetails.map(lob =>
            lob.id === selectedLOB.id ? { ...lob, description: e.target.value } : lob
        ));
    };

    const handleSelectedLobApplicationChange = (values: any[]) => {
        const value = values[0];
        setSelectedLobDetails({
            ...selectedLOB,
            uiCodeLOBSId: value
        });
        setLobDetails(lobDetails.map(lob =>
            lob.id === selectedLOB.id ? { ...lob, uiCodeLOBSId: value } : lob
        ));
    };

    const handleLobFormTypeChange = (values: any[]) => {
        const value = values[0];
        setSelectedLobDetails({
            ...selectedLOB,
            formTypeId: value
        });
        setLobDetails(lobDetails.map(lob =>
            lob.id === selectedLOB.id ? { ...lob, formTypeId: value } : lob
        ));

        let updatedPolicyDetails = { ...customerpolicyDetail.selectedPolicyDetails?.[policyDetailKey] };
        if (updatedPolicyDetails.policyLineOfBusinesses) {
            updatedPolicyDetails.policyLineOfBusinesses = updatedPolicyDetails.policyLineOfBusinesses.map(lob =>
                lob.id === selectedLOB.id ? { ...lob, formTypeId: value } : lob
            );
            dispatch(updateSelectedPolicyDetails({ policyId, polEventId, policyDetails: updatedPolicyDetails }));
        }
    };

    function mergeLobFields(policyDetails, lobDetails) {
        if (policyDetails.policyLineOfBusinesses && lobDetails.length > 0) {
            policyDetails.policyLineOfBusinesses = policyDetails.policyLineOfBusinesses.map(originalLob => {
                const updatedLob = lobDetails.find(lob => lob.id === originalLob.id);
                if (updatedLob) {
                    return {
                        ...originalLob,
                        description: updatedLob.description,
                        uiCodeLOBSId: updatedLob.uiCodeLOBSId
                    };
                }
                return originalLob;
            });
        }
        return policyDetails;
    }

    const renderCoverageAccordionItem = (
        headerLabel: string,
        children: React.ReactNode,
        validationErrorKey?: string,
        accordionTabIndex?: number
    ) => {
        const errorClass = validationErrorKey && hasValidationError(validationErrorKey) ? 'has-error' : '';
        return (
            <Accordion.Item 
                eventKey={"3"} 
                className={`accordion-item accordion-item-100 border-top ${errorClass}`}
            >
                <Accordion.Button tabIndex={accordionTabIndex}>{headerLabel.toUpperCase()}</Accordion.Button>
                <Accordion.Body>{children}</Accordion.Body>
            </Accordion.Item>
        );
    };
    const renderCoverageSection = () => {
            switch (selectedLOBCodeId) {
                case constant.CUSTOMER_POLICY_LOBCodeId.FLOOD:
                    return renderCoverageAccordionItem(
                        cstPolicyDetailLabel.FLOOD_COVERAGE_LABEL,
                        <CustomerEditPolicyFloodCoverageGrid
                            customerId={policySummary.custId}
                            policyId={policySummary.id}
                            policyEventId={polEventId}
                            validationErrors={formValidation}
                            tabIndex={301}
                        />,
                        constant.ValidationErrorNameList.FLOODCOVERAGE,
                        300
                    );
                
                default:
                    return renderCoverageAccordionItem(
                        cstPolicyDetailLabel.BASIC_COVERAGE,
                        <CustomerEditPolicyBasicCoverageGrid
                            customerId={policySummary.custId}
                            policyId={policySummary.id}
                            policyEventId={polEventId}
                            validationErrors={formValidation}
                            tabIndex={301}
                        />,
                        constant.ValidationErrorNameList.COVERAGE,
                        300
                    );
            }
    };

    useEffect(() => {
        if (!isLoading) {
            if (firstControlTransactionTypeRef.current) {
                firstControlTransactionTypeRef.current.focus();
            }
        }
    }, [isLoading]);
    
    return (
        <div className="customer-edit-policy-details-container">
            {
                //isVisible &&
                policySummary &&
                <>
                    <div className="dv-cst-actions sticky-action-bar p-2 text-end d-flex align-items-center gap-2">
                        <Button
                            onClick={props.onAddNewPolicy}
                            tabIndex={565}
                        >
                            <i className="bi bi-plus-circle me-2"></i>
                            {labelconstant.PolicyActionLabels.ADD_NEW_POLICY}
                        </Button>
                        <Button
                            variant="outline-primary"
                            onClick={() => onCancel()}
                            id="btnCancel"
                            className="btn-cancel me-2"
                            tabIndex={570}
                        >
                            {label.CANCEL.toLocaleUpperCase()}
                        </Button>
                        <Button
                            variant="outline-primary"
                            onClick={() => handleSaveButtonClick()}
                            id="btnSave"
                            className="btn-save me-2"
                            tabIndex={575}
                        >
                            {label.SAVE.toLocaleUpperCase()}
                        </Button>
                        <Button
                            variant="outline-primary"
                            ref ={lastControlButtonRef}
                            onClick={() => handleSaveAndClose()}
                            id="btnSaveAndClose"
                            className="btn-save-close me-2"
                            tabIndex={580}
                            keyDown={(e) => {
                                if (e.key == "Tab" && !e.shiftKey) {
                                    // When the button loses focus, move focus to the first control in the form
                                    if (firstControlTransactionTypeRef.current) {
                                        firstControlTransactionTypeRef.current.focus();
                                        e.preventDefault();
                                    }
                                }
                            }}
                        >
                            SAVE AND CLOSE
                        </Button>
                    </div>
                    <div className="child-card">
                    <CustomerPolicySummary policySummary={policySummary} isEditPolicyActivated={true}></CustomerPolicySummary>
                    {isLoading ? <Spinner type="SyncLoader" loading={isLoading} /> :
                    <Panel cardBodyClassName={'item-chid-panel'}>
                            {/* TRANSACTION header row */}
                            {policyTransactionDetails && (
                                <>
                                    <Row className="mb-3">
                                        <Column>
                                            <div className="transaction-header-row">
                                                <span className="transaction-label">{cstPolicyDetailLabel.TRANSACTION}</span>
                                                <span>
                                                        <InputGroup className="mb-3">
                                                            <InputGroup.Text ref={firstControlTransactionTypeRef} tabIndex={tabIndexCounter++}
                                                                onKeyDown={(e) => {
                                                                    if (e.key == "Tab" && e.shiftKey) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}      >
                                                            {cstPolicyDetailLabel.TRANSACTION_EFFECTIVE_DATE}
                                                            <span className="text-danger ms-1">*</span>
                                                        </InputGroup.Text>
                                                            <DatePicker
                                                                tabIndex={tabIndexCounter++}
                                                            dateFormatCalendar="LLLL yyyy"
                                                            dropdownMode="scroll"
                                                            selected={CommonUtility.datetimeToDateOnlyObject(policyTransactionDetails.tranEffDate)}
                                                            onChange={(date) => handleTransactionEffectiveDateChange(date)}
                                                            className={`form-control ${policyTransactionDetails.tranEffDate ? '' : 'is-invalid'}`}

                                                                    />
                                                            <InputGroup.Text>
                                                                <i className="bi bi-calendar3" tabIndex={tabIndexCounter++}></i>
                                                        </InputGroup.Text>
                                                    </InputGroup>
                                                    {(!policyTransactionDetails?.tranEffDate || policyTransactionDetails?.tranEffDate.toString().trim() === "") && formValidation['tranEffDate'] && (
                                                        <div className="mt-1 cst-error text-danger invalid-feedback">
                                                            {formValidation['tranEffDate']?.warningText}
                                                        </div>
                                                    )}
                                                </span>                          
                                                <span>
                                                    <Select
                                                        id='transactionType'
                                                        label={cstPolicyDetailLabel.TRANSACTION_TYPE}
                                                        options={[...transactionTypeList]}
                                                        defaultSelected={transactionTypeList.filter(opt => opt.value === policyTransactionDetails.tranType)}
                                                        onChange={handleTransactionTypeChange}
                                                        placeholder={constant.PLEASE_SELECT}
                                                        multiple={false}
                                                        showAsFloatingLabel={true}
                                                        className='mb-3'
                                                        tabIndex={tabIndexCounter++}
                                                    />
                                                </span>
                                                {cancellationTranTypes.includes(policyTransactionDetails?.tranType) && (
                                                    <span>
                                                        <Select
                                                            key={policyTransactionDetails?.tranType}
                                                            id='cancellationReason'
                                                            label={label.PolicyActionLabels.CANCELLATION_REASON_LABEL}
                                                            options={[...cancellationReasonList]}
                                                            defaultSelected={cancellationReasonList.filter(opt => opt.value === policyTransactionDetails?.cancellationReasonId)}
                                                            onChange={handleCancellationReasonChange}
                                                            placeholder={constant.PLEASE_SELECT}
                                                            multiple={false}
                                                            showAsFloatingLabel={true}
                                                            className='mb-3'
                                                            tabIndex={tabIndexCounter++}
                                                        />
                                                    </span>
                                                )}
                                                <span>
                                                    <FloatingLabel
                                                        controlId="tranNote"
                                                        label={cstPolicyDetailLabel.TRANSACTION_DESCRIPTION}
                                                        className="mb-3">
                                                        <Form.Control
                                                            type="text"
                                                            name="tranNote"
                                                            value={policyTransactionDetails.tranNote || ''}
                                                            onChange={e => {
                                                                const newTranNote = e.target.value;
                                                                setPolicyTransactionDetails({ ...policyTransactionDetails, tranNote: newTranNote });
                                                                let updatedPolicyDetails = { ...customerpolicyDetail.selectedPolicyDetails?.[policyDetailKey] };
                                                                if (updatedPolicyDetails.policyEvents) {
                                                                    updatedPolicyDetails.policyEvents = updatedPolicyDetails.policyEvents.map(ev =>
                                                                        ev.id === policyTransactionDetails.id
                                                                            ? { ...ev, tranNote: newTranNote }
                                                                            : ev
                                                                    );
                                                                    dispatch(updateSelectedPolicyDetails({ policyId, polEventId, policyDetails: updatedPolicyDetails }));
                                                                }
                                                            }}
                                                            placeholder={cstPolicyDetailLabel.TRANSACTION_DESCRIPTION}
                                                            tabIndex={tabIndexCounter++}
                                                        />
                                                    </FloatingLabel>
                                                </span>
                                            </div>
                                        </Column>
                                    </Row>
                                    <Row className="mb-3">
                                        <Column>
                                            <div className="custom-tab-list d-flex">
                                                {lobDetails?.map((lobDetail) => (
                                                    <div
                                                        key={lobDetail.id}
                                                        className={`custom-tab px-3 py-2 me-2 ${lobDetail.id === selectedLOB?.id ? 'active' : ''}`}
                                                        onClick={() => {
                                                            const latestLob = lobDetails.find(lob => lob.id === lobDetail.id);
                                                            setSelectedLobDetails(latestLob || lobDetail);
                                                        }}
                                                        tabIndex={tabIndexCounter++}
                                                    >
                                                        {getLobLabel(lobDetail.lobCodeId)}
                                                    </div>
                                                ))}
                                            </div>
                                        </Column>
                                    </Row>
                                    {selectedLOB && selectedLOB.id && lobDetails.length > 0 && (
                                            <Row className="mb-3">
                                                <Column md={3}>
                                                    <FloatingLabel
                                                        controlId={`lob-description-${selectedLOB?.id}`}
                                                        label={cstPolicyDetailLabel.DESCRIPTION}
                                                        className="mb-0">
                                                        <Form.Control
                                                            type="text"
                                                            name="lobDescription"
                                                            value={selectedLOB?.description || ""}
                                                            onChange={handleSelectedLobDescriptionChange}
                                                            placeholder={cstPolicyDetailLabel.TRANSACTION_DESCRIPTION}
                                                            tabIndex={tabIndexCounter++}
                                                        />
                                                    </FloatingLabel>
                                                </Column>
                                                <Column md={3}>
                                                    <Select
                                                        id={`lob-application-${selectedLOB?.id}`}
                                                        label={"Application"}
                                                        options={[...lobApplicationList]}
                                                        defaultSelected={lobApplicationList.filter(opt => opt.value === selectedLOB?.uiCodeLOBSId)}
                                                        onChange={handleSelectedLobApplicationChange}
                                                        placeholder={constant.PLEASE_SELECT}
                                                        multiple={false}
                                                        showAsFloatingLabel={true}
                                                        className="mb-3"
                                                        tabIndex={tabIndexCounter++}
                                                    />
                                                </Column>
                                                <Column md={3}>
                                                    <Select
                                                        id='formType'
                                                        label={cstPolicyDetailLabel.FORM_TYPE}
                                                        options={[...formTypeList]}
                                                        defaultSelected={formTypeList.filter(opt => opt.value === (selectedLOB?.formTypeId || policySummary?.formTypeId))}
                                                        onChange={handleLobFormTypeChange}
                                                        placeholder={constant.PLEASE_SELECT}
                                                        multiple={false}
                                                        showAsFloatingLabel={true}
                                                        className='mb-3'
                                                        tabIndex={tabIndexCounter++}
                                                    />
                                                </Column>
                                            </Row>
                                    )}
                                </>
                            )}
                        <Row>
                            <Column>
                                <Accordion defaultActiveKey={["-1"]}>
                                {lobDetails?.some(lob => lob.lobCodeId === constant.CUSTOMER_POLICY_LOBCodeId.PRIVATE_PASSENGER_AUTO) && (
                                        <Accordion.Item eventKey="-3" className={`accordion-item accordion-item-100 border-top ${hasValidationError(constant.ValidationErrorNameList.BASICVEHICLE) ? 'has-error' : ''}`}>
                                            <Accordion.Button tabIndex={600}>{cstPolicyDetailLabel.BASIC_VEHICLE_INFORMATION}</Accordion.Button>
                                            <Accordion.Body>
                                                <CustomerBasicVehicleGrid
                                                    customerId={policySummary.custId}
                                                    policyId={policySummary.id}
                                                    polEventId={policyEventDetails.polEventId}
                                                    validationErrors={formValidation}
                                                    tabIndex={602}
                                                />
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )}
                                    {/*<Accordion defaultActiveKey="0">*/}
                                    <Accordion.Item eventKey="-2" className="accordion-item accordion-item-100 border-top">
                                        <Accordion.Button tabIndex={80}>{cstPolicyDetailLabel.POLICY_TRANSACTION_PREM}</Accordion.Button>
                                        <Accordion.Body>
                                            <PolicyTransactionPremiumGrid
                                                // customerId={policySummary.custId}
                                                policyId={policySummary.id}
                                                polEventId={polEventId}
                                                tabIndex={81}
                                            />
                                            {/* Commission Reconciliation — security-gated */}
                                            {canViewCommissions && (
                                              <div className="mt-2">
                                                <Button
                                                  color="primary"
                                                  outlined
                                                  onClick={() => setShowCommissions((prev) => !prev)}
                                                >
                                                  {showCommissions ? "Hide Commissions" : "Commissions"}
                                                </Button>
                                                {showCommissions && <CommissionReconciliation />}
                                              </div>
                                            )}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="-1" className={`accordion-item accordion-item-100 border-top ${hasValidationError(constant.ValidationErrorNameList.LOCATION) ? 'has-error' : ''
                                        }`}>
                                    <Accordion.Button tabIndex={100}>{shouldShowPropertyAddress() ? cstPolicyDetailLabel.PROPERTY_ADDRESS : cstPolicyDetailLabel.POLICY_DETAIL_LOC}</Accordion.Button>
                                        
                                        <Accordion.Body>
                                            <CustomerPolicyLocationGrid
                                                customerId={policySummary.custId}
                                                policyId={policySummary.id}
                                                polEventId={polEventId}
                                                validationErrors={formValidation}
                                                tabIndex={102}
                                            />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="0" 
                                    className={`accordion-item accordion-item-100 border-top ${hasValidationError(constant.ValidationErrorNameList.INSURED) ? 'has-error' : ''
                                        }`}>
                                        <Accordion.Button tabIndex={150} >{cstPolicyDetailLabel.INSURED_NAME}</Accordion.Button>
                                        <Accordion.Body>
                                            <CustomerInsured
                                                customerId={policySummary.custId}
                                                 validationErrors={formValidation}
                                                 tabIndex={151}
                                            />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1" 
                                       className={`accordion-item accordion-item-100 border-top ${hasValidationError(constant.ValidationErrorNameList.COINSURED) ? 'has-error' : ''
                                        }`}>
                                        <Accordion.Button tabIndex={180}  >{cstPolicyDetailLabel.CO_INSURED}</Accordion.Button>
                                        <Accordion.Body>
                                            <CustomerCoInsured tabIndex={181} validationErrors={formValidation}/>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2" 
                                    className={`accordion-item accordion-item-100 border-top ${hasValidationError(constant.ValidationErrorNameList.BASICPOLICY) ? 'has-error' : ''
                                        }`}>
                                        <Accordion.Button tabIndex={210} >{cstPolicyDetailLabel.BASIC_POLICY_INFORMATION}</Accordion.Button>
                                        <Accordion.Body>
                                            <CustomerBasicPolicyInfo
                                                customerId={policySummary.custId}
                                                 validationErrors={formValidation}
                                                 tabindex={211}
                                            />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                   {renderCoverageSection()}
                                      
                                    <Accordion.Item eventKey="4" className={`accordion-item accordion-item-100 border-top ${hasValidationError(constant.ValidationErrorNameList.ENDORSEMENT) ? 'has-error' : '' }`}>
                                        <Accordion.Button tabIndex={400} > {cstPolicyDetailLabel.ENDORSEMENTS.toUpperCase()}</Accordion.Button>
                                        <Accordion.Body>
                                            <CustomerEditPolicyEndorsementGrid
                                                customerId={policySummary.custId}
                                                policyId={policySummary.id}
                                                policyEventId={polEventId}
                                                validationErrors={formValidation}
                                                tabIndex={401}
                                            />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="5" className={`accordion-item accordion-item-100 border-top ${hasValidationError(constant.ValidationErrorNameList.FLOODUNDERWRITING) ? 'has-error' : ''}`}>
                                        <Accordion.Button tabIndex={500}>{selectedLOBCodeId === constant.CUSTOMER_POLICY_LOBCodeId.HOMEOWNERS ? cstPolicyDetailLabel.UNDERWRITING_RATING : cstPolicyDetailLabel.UNDERWRITING.toUpperCase()}</Accordion.Button>
                                        <Accordion.Body>
                                            {selectedLOBCodeId === constant.CUSTOMER_POLICY_LOBCodeId.FLOOD ? (
                                                <CustomerEditPolicyFloodUnderwriting tabIndex={501} validationErrors={formValidation}/>
                                            ) : (
                                                <CustomerPolicyUnderwriting 
                                                    tabIndex={501}
                                                    validationErrors={formValidation}
                                                />
                                            )}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="6" className={`accordion-item accordion-item-100 border-top ${hasValidationError(constant.ValidationErrorNameList.ADDITIONALINTEREST) ? 'has-error' : ''}`}>
                                        <Accordion.Button tabIndex={560}>{cstPolicyDetailLabel.ADDITIONAL_INTERESTS.toUpperCase()}</Accordion.Button>
                                            <Accordion.Body>
                                                <CustomerAdditionalInterestsList tabIndex={561}/>
                                            </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </Column>
                        </Row>
                    </Panel>
                    }
                     </div>
                </>
            }
       
        </div>
    );
};

export default CustomerEditPolicyDetails;
